import { SofiaEnvironment, SofiaEnvironmentEntry } from "@/sofia-environment"

const ENVIRONMENT_PREFIX_MAP: Record<SofiaEnvironmentEntry, string | null> = {
  local: "DEV",
  int: "INT",
  migr: "MIGR",
  qa: "QA",
  vina: "VNA",
  vino: "VNO",
  vinapp: "APP",
  uat: "UAT",
  preprod: "PP",
  training: "TRA",
  production: null,
}

const getEnvironmentPrefix = (): string | null => {
  const env = SofiaEnvironment.CurrentEnvironment
  return ENVIRONMENT_PREFIX_MAP[env]
}

export const getEnvironmentTitlePrefix = (): string => {
  const prefix = getEnvironmentPrefix()
  return prefix ? `${prefix}: ` : ""
}

// Callers always pass raw titles (never pre-prefixed), so unconditional prepend is safe.
export const setDocumentTitle = (title: string): void => {
  const prefix = getEnvironmentTitlePrefix()
  document.title = prefix ? `${prefix}${title}` : title
}
